import state from "./moduleSessionApiState.js";
import mutations from "./moduleSessionApiMutations.js";
import actions from "./moduleSessionApiActions.js";
import getters from "./moduleSessionApiGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
